export default [
  {
    path: '/ticketResource/ticketHome',
    component: () => import('../pages/ticketHome/index.vue'),
    name: 'TicketHome',
    meta: {
      title: '首页',
      activeBar: 'booking',
    },
  },
  {
    path: '/ticketResource/ticketList',
    component: () => import('@/ticketResource/pages/ticketList/index.vue'),
    name: 'TicketList',
    meta: {
      title: '门票列表',
      activeBar: 'booking',
    },
  },
  {
    path: '/ticketResource/ticketDetail',
    name: 'TicketDetail',
    component: () => import('@/ticketResource/pages/ticketDetail/index.vue'),
    meta: { title: '门票详情' },
  },
  {
    path: '/ticketResource/ticketBooking',
    component: () => import('@/ticketResource/pages/ticketBooking/index.vue'),
    name: 'TicketBooking',
    meta: {
      title: '门票预订',
      activeBar: 'booking',
    },
  },
  {
    path: '/ticketResource/ticketBooking/travelerSelect',
    component: () => import('@/ticketResource/pages/ticketBooking/travelerSelect/index.vue'),
    name: 'TicketTravelerSelect',
    meta: {
      title: '选择旅客',
      activeBar: 'booking',
    },
  },
  {
    path: '/ticketResource/ticketBooking/travelerEdit',
    component: () => import('@/ticketResource/pages/ticketBooking/travelerEdit/index.vue'),
    name: 'TicketTravelerEdit',
    meta: {
      title: '编辑旅客',
      activeBar: 'booking',
    },
  },
  {
    path: '/ticketResource/citySelect',
    component: () => import('@/ticketResource/pages/citySelect/index.vue'),
    name: 'CitySelect',
    meta: {
      title: '城市选择',
      activeBar: 'booking',
    },
  },
]
